import React from "react";
import { ScreenshotHelperOverlay } from "components/util/helpers/screenshot_helper/ScreenshotHelper";

// Host side of sbv.useScreenshotHelper. The project's app asks for a screenshot over the
// bridge and the overlay runs here — one implementation, the same one the platform uses
// for itself, reaching styles and fonts the project does not own.
//
// The capturable surface is the whole section container, not the element that armed the
// capture: the point of arming one from a topbar is to let the user point at the content
// beside it.
//
// Only one capture runs at a time — the user can only point at one thing.

const LAYOUT_ROOT_ID = "presentation-content";

const ScreenshotPortal = ({ request, onFinish }) => {

  if (!request) return null;

  // Resolved on demand rather than held in a ref: a request only exists once a
  // view has rendered, so the container is already in the document by then.
  const rootNode = document.getElementById(LAYOUT_ROOT_ID) || document.body;

  return (
    <ScreenshotHelperOverlay
      key={request.requestId}
      backgroundColor={request.options?.backgroundColor}
      captureScale={request.options?.captureScale}
      rootNode={rootNode}
      onCancel={() => onFinish(null)}
      onCapture={(result) => onFinish(result)}
    />
  );

}

export default ScreenshotPortal;
